module.exports = __webpack_public_path__ + "static/10_norsk-6c9f290a2ed45074583b2aa7d710d247.png";